const getters = {
  userInfo: state => state.app.userInfo,
  isMobile: modules => modules.app.isMobile,
  publishStatus: state => state.app.publishStatus,
  userinfologin: state => state.app.userinfologin,
  timeDiff: state => state.app.timeDiff,
  shareTitle: state => state.app.shareTitle,
  operateCode: state => state.app.operateCode,
  shareList: state => state.app.shareList,
  operate: state => state.app.operate,
  infoList: state => state.app.infoList,
  fourList: state => state.app.fourList,
  ewmList: state => state.app.ewmList,
  youList: state => state.app.youList,
  classList: state => state.app.classList,
  areaList: state => state.app.areaList,
  histList: state => state.app.histList,
  types: state => state.app.types,
  areaData: state => state.app.areaData,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js